import * as ActiveStorage from "@rails/activestorage";
ActiveStorage.start();
